import React, { useState } from 'react';
import { pageSectionHeadingClass } from './challengeWireFormStyles';

const OPEN_BY_DEFAULT_WHEN_NON_EMPTY = new Set(['needs-you', 'waiting']);

function sectionIsOpen(section, openSections) {
	if (Object.prototype.hasOwnProperty.call(openSections, section.id)) {
		return Boolean(openSections[section.id]);
	}
	return OPEN_BY_DEFAULT_WHEN_NON_EMPTY.has(section.id) && section.items.length > 0;
}

export default function ChallengeWireChallengeSections({ sections, renderGrid }) {
	const [openSections, setOpenSections] = useState({});

	function toggleSection(section) {
		setOpenSections((prev) => ({
			...prev,
			[section.id]: !sectionIsOpen(section, prev)
		}));
	}

	return (
		<div className="space-y-8">
			{sections.map((section) => {
				const isOpen = sectionIsOpen(section, openSections);

				return (
					<section key={section.id}>
						<button
							type="button"
							aria-expanded={isOpen}
							onClick={() => toggleSection(section)}
							className="flex items-center gap-2 text-left group"
						>
							<h2 className={pageSectionHeadingClass}>{section.title}</h2>
							<i
								className={`fa-solid text-gray-500 dark:text-gray-300 group-hover:text-gray-700 dark:group-hover:text-gray-200 ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}
								aria-hidden="true"
							/>
						</button>
						{isOpen && <div className="mt-3">{renderGrid(section.items)}</div>}
					</section>
				);
			})}
		</div>
	);
}
